import React from "react";
import { Text } from "@website-builder/ui/shared/elements";
import { BoldTextWrapper, TextItem } from "./style";

const BoldText = ({ textItems = [], mobileText = null, sectionName }) => {
	const isTwoColumnSectionContent = sectionName === "TwoColumnSection";
	return (
		<BoldTextWrapper isTwoColumnSectionContent={isTwoColumnSectionContent}>
			<div className={mobileText ? "desktop-text" : null}>
				{textItems.map((item) => {
					return (
						<TextItem fs={item?.size}>
							<Text
								className="rich-text-wrapper"
								tag="div"
								dangerouslySetInnerHTML={{ __html: item?.text }}
							/>
						</TextItem>
					);
				})}
			</div>
			<div className="mobile-text">
				<TextItem>
					<Text
						className="rich-text-wrapper"
						variant="paragraph_L"
						tag="div"
						dangerouslySetInnerHTML={{ __html: mobileText }}
					/>
				</TextItem>
			</div>
		</BoldTextWrapper>
	);
};

export default BoldText;
